import React from 'react'
import { Divider, makeStyles, mergeClasses, tokens } from '@fluentui/react-components'
import { Text } from '../text/Text'
import { ISummaryField } from '../../../interfaces/ISummaryField'

const useStyles = makeStyles({
   fieldWrapper: {
      display: 'flex',
      gap: tokens.spacingHorizontalL,
      alignItems: 'center',
      '@media screen and (max-width: 640px)': {
         width: '100%',
         justifyContent: 'space-between',
         '& p': {
            margin: 0,
         },
      },
   },

   summaryRow: {
      backgroundColor: tokens.colorNeutralBackground6,
      display: 'flex',
      gap: `calc(${tokens.spacingHorizontalXL} * 2)`,
      justifyContent: 'end',
      alignItems: 'center',
      padding: `0 ${tokens.spacingHorizontalXL}`,
      '@media screen and (max-width: 640px)': {
         gap: tokens.spacingHorizontalS,
         flexDirection: 'column',
         padding: `${tokens.spacingHorizontalS} ${tokens.spacingHorizontalXL}`,
         border: `1px solid ${tokens.colorNeutralStroke1}`,
      },
   },
   summaryRowWrapper: {
      margin: `${tokens.spacingHorizontalM} 0`,
      '@media screen and (max-width: 640px)': {
         margin: '0',
      },
   },
   hideInPhone: {
      '@media screen and (max-width: 640px)': {
         display: 'none',
      },
   },
   moveLeft: {
      marginRight: 'auto',
   },
})
type SummaryRowProps = {
   summaryFields: ISummaryField[]
   className?: string
}
export const SummaryRow = ({ summaryFields, className }: SummaryRowProps) => {
   const classes = useStyles()
   return (
      <div className={mergeClasses(className ?? '', classes.summaryRowWrapper)}>
         <Divider className={classes.hideInPhone} />
         <div className={mergeClasses(classes.summaryRow)}>
            {summaryFields.map((summary) => (
               <div key={summary.label} className={mergeClasses(classes.fieldWrapper, summary.alignStart ? classes.moveLeft : '')}>
                  <Text weight="bold">{summary.label}</Text>
                  <Text>{summary.text}</Text>
               </div>
            ))}
         </div>
         <Divider appearance="strong" className={classes.hideInPhone} />
      </div>
   )
}
